import { language } from '@Language';
import { checkOutStore } from '@Stores/MainStore';
import { isArray, isNothing, someOf } from '@Utils/Utils';
import { get, has, keys, first, omit, isArrayLikeObject, startsWith } from 'lodash';
import { language as l } from '@Language';
import { isObservableArray } from 'mobx';
import { throatArray, throatBoolean, throatObject } from './ConfigsHeader';
import * as K from './Keywords';
class classShippingMethods {

    WarehouseEnabled = {
        /* // an example for warehouse case
        [K.Indonesia]: true */
    }

    WarehouseAcceptance = {
        /* // an example for warehouse case
        [K.Indonesia]: ['jakarta', 'surabaya'] */
    }

    ShippingAcceptance = {
        [K.Korea]: ['delivery', 'pickUp'],
        /* // an example for pickup with special case
        [K.Philippines]: ['delivery', 'pickUp.ph_taguig'],
        /* // an example for warehouse case
        [K.Indonesia]: {
            jakarta: ['delivery', 'pickUp', 'motorDelivery.id_jakarta'],
            surabaya: ['delivery', 'pickUp', 'motorDelivery.id_surabaya']
        }, */
    }

    ShippingDeclaration = {
        [K.Delivery]: {
            [K.Default]: {
                value: '2',
                dictionary: 'od_shipping_delivery'
            }
        },
        [K.PickUp]: {
            [K.Default]: {
                value: '3',
                dictionary: 'od_shipping_pickup'
            },
            /* // an example for special case
            ph_taguig: {
                value: '32',
                dictionary: 'u_ph_od_shipping_pickup_taguig'
            } */
        },
        [K.Aramex]: {
            [K.Default]: {
                value: '4',
                dictionary: 'od_shipping_aramex'
            }
        },
        [K.MotorDelivery]: {
            id_jakarta: {
                value: '6',
                dictionary: 'od_shipping_motor_delivery'
            },
            id_surabaya: {
                value: '9',
                dictionary: 'od_shipping_motor_delivery'
            }
        },
        [K.SamedayDelivery]: {
            [K.Default]: {
                value: '501',
                dictionary: 'u_ph_od_shipping_sameday_delivery'
            }
        }
    }

    AramexDeclaration = {
        address: {
            /* // an example for address
            [K.Singapore]: {
                address1: 'Aramax (AIC Dept.) 3 Changi South Street 1, #01-01',
                address2: 'Santa United International  Bldg.',
                city: 'Singapore',
                state: '',
                zip: '486795',
                country: 'SG',
                mobilePhone: '6565430300'
            } */
        }
    }

    PickupDeclaration = {
        address: {
            [K.Korea]: {
                dictionary: 'od_pickup_address',
                value: {
                    KR: {
                        fullName: 'Korea, Main Office',
                        address1: '154-1 서린동',
                        address2: '남제주군',
                        state: '',
                        city: '서울',
                        country: 'KR',
                        zip: '688823'
                    },
                    EN: {
                        fullName: 'Korea, Main Office',
                        address1: '154-1 Seorin-dong',
                        address2: 'Namjeju-gun',
                        state: '',
                        city: 'Seoul',
                        country: 'KR',
                        zip: '688823'
                    }
                }
            }
            /* // an example for address
            [K.Thailand]: {
                dictionary: 'od_pickup_address',
                value: {
                    TH: {
                        fullName: 'Bangkok, Main Office',
                        address1: '44/1 ชั้น 1 และชั้น 15 อาคารรุ่งโรจน์ธนกุล',
                        address2: 'ถนนรัชดาภิเษก เขตห้วยขวาง',
                        city: 'กรุงเทพมหานคร',
                        country: 'TH',
                        zip: '10310'
                    },
                    EN: {
                        fullName: 'Bangkok, Main Office',
                        address1: '44/1 Ground floor and 15 floor',
                        address2: 'Rungrojthanakul Building Ratchadapisek Road, Huaykwang',
                        city: 'Bangkok',
                        country: 'TH',
                        zip: '10310'
                    }
                }
            }, 
            [K.Singapore]: {
                dictionary: 'od_pickup_address',
                value: {
                    fullName: 'Singapore Main Office',
                    address1: '3 Temasek Boulevard',
                    address2: '#01-351, Suntec City Mall (West Wing)',
                    city: 'Singapore',
                    state: '',
                    zip: '038983',
                    country: 'SG'
                }
            },
            [K.Indonesia]: {
                jakarta: {
                    dictionary: 'od_pickup_address_jakarta',
                    value: {
                        fullName: 'Jakarta Office',
                        address1: 'Gedung Perkantoran Bidakara 2 Lt.15 Unit 2',
                        address2: 'Jl. Jend. Gatot Subroto Kav 71-7',
                        city: 'Jakarta Selatan',
                        state: '',
                        zip: '12870',
                        country: 'ID'
                    }
                },
                surabaya: {
                    dictionary: 'od_pickup_address_surabaya',
                    value: {
                        fullName: 'Surabaya Office',
                        address1: 'Intiland Tower Surabaya 1st floor Suite 1',
                        address2: 'Jl. Panglima Sudirman No.101-103, Embong Kaliasin',
                        city: 'KEC. Genteng - Kota Surabaya - Jawa Timur',
                        state: '',
                        zip: '60271',
                        country: 'ID'
                    }
                }
            },
            [K.Hongkong]: {
                dictionary: 'od_pickup_address',
                value: {
                    HK: {
                        fullName: 'Main Office',
                        address1: 'Room 1118, 11/F Leighton Centre',
                        address2: '77 Leighton Road',
                        city: 'Causeway Bay',
                        state: '',
                        country: 'HK',
                        zip: ''
                    },
                    EN: {
                        fullName: 'Main Office',
                        address1: 'Room 1118, 11/F Leighton Centre',
                        address2: '77 Leighton Road',
                        city: 'Causeway Bay',
                        country: 'HK',
                        state: '',
                        zip: ''
                    }
                }
            }, */
        }
    }

    MotorDeliveryDeclaration = {
        address: {
            [K.Indonesia]: {
                jakarta: {
                    province: 'Jadetabek'
                },
                surabaya: {
                    province: 'Jawa Timur'
                }
            }
        },
        options: {
            [K.Indonesia]: {
                jakarta: {
                    'Jakarta Pusat': {
                        'Gambir': ['Gambir', 'Kebon Kalapa', 'Petojo Utara', 'Duri Pulo', 'Cideng', 'Petojo Selatan'],
                        'Tanah Abang': ['Bendungan Hilir', 'Karet Tengsin', 'Kebon Melati', 'Kebon Kacang', 'Kampung Bali', 'Petamburan', 'Gelora'],
                        'Menteng': ['Menteng', 'Pegangsaan', 'Cikini', 'Kebon Sirih', 'Gondangdia'],
                        'Senen': ['Senen', 'Kwitang', 'Kenari', 'paseban', 'Kramat', 'Bungur'],
                        'Cempaka Putih': ['Cempaka Putih Timur', 'Cempaka Putih Barat', 'Rawa Sari'],
                        'Johar Baru': ['Galur', 'Tanah Tinggi', 'Kampung Rawa', 'Johar Baru'],
                        'Kemayoran': ['Gunung Sahari Selatan', 'kemayoran', 'Kebon Kosong', 'Cempaka Baru', 'Harapan Mulia', 'Sumur Batu', 'Serdang', 'Utan Panjang'],
                        'Sawah Besar': ['Pasar Baru', 'Gunung Sahari Utara', 'Mangga Dua Selatan', 'Karang Anyar', 'Kartini'],
                    },
                    'Jakarta Barat': {
                        'Taman Sari': ['Pinangsia', 'Glodok', 'Keagungan', 'Krukut', 'Taman Sari', 'Mahpar', 'Tangki', 'Mangga Besar'],
                        'Tambora': ['Tanah Sereal', 'Tambora', 'Roa Malaka', 'Pekojan', 'Jembatan Lima', 'Kerendang', 'Duri Selatan', 'Duri Utara', 'Kali Anyar', 'Jembatan Besi', 'Angke'],
                        'Pal Merah': ['Slipi', 'Kota Bambu Selatan', 'Kota Bambu Utara', 'Jati Pulo', 'Kemanggisan', 'Pal Merah'],
                        'Grogol Petamburan': ['Tomang', 'Grogol', 'Jelambar', 'Jelambar Baru', 'Wijaya Kusuma', 'Tanjung Duren Selatan', 'Tanjung Duren Utara'],
                        'Kebon Jeruk': ['Duri Kelapa', 'Kedoya Selatan', 'Kedoya Utara', 'Kebon Jeruk', 'Sukabumi Utara', 'Kelapa Dua', 'Sukabumi Selatan'],
                        'Kembangan': ['Kembangan Selatan', 'Kembangan Utara', 'Meruya Utara', 'Srengseng', 'Joglo', 'Meruya Selatan'],
                        'Cengkareng': ['Kedaung Kali Angke', 'Kapuk', 'Cengkareng Barat', 'Cengkareng Timur', 'Rawa Buaya', 'Duri Kosambi'],
                        'Kali Deres': ['Kamal', 'Tegal Alur', 'Pegadungan', 'Kali Deres', 'Semanan'],
                    },
                    'Jakarta Selatan': {
                        'Kebayoran Baru': ['Selong', 'Gunung', 'Kramat Pela', 'Gandaria Utara', 'Cipete Utara', 'Melawai', 'Pulo', 'Petogogan', 'Rawa Barat', 'Senayan'],
                        'Kebayoran Lama': ['Grogol Utara', 'Grogol Selatan', 'Cipulir', 'Kebayoran Lama Selatan', 'Kebayoran Lama Utara', 'Pondok Pinang'],
                        'Kec. Pesanggrahan': ['Ulujami', 'Petukangan Utara', 'Petukangan Selatan', 'Pesanggrahan', 'Bintaro'],
                        'Cilandak': ['Cipete Selatan', 'Gandaria Selatan', 'Cilandak Barat', 'Lebak Bulus', 'Pondok Labu'],
                        'Pasar Minggu': ['Pejaten Barat', 'Pejaten Selatan', 'Kebagusan', 'Pasar Minggu', 'Jati Padang', 'Ragunan', 'Cilandak Timur'],
                        'Jagakarsa': ['Tanjung Barat', 'Lenteng Agung', 'Jagakarsa', 'Ciganjur', 'Cipendak', 'Srengseng Sawah'],
                        'Mampang Prapatan': ['Kuningan Barat', 'Kuningan Timur', 'Bangka', 'Pancoran', 'Mampang Prapatan', 'Tegal Parang'],
                        'Pancoran': ['KaliBata', 'Rawa jati', 'Duren Tiga', 'Cikoko', 'Pengadegan'],
                        'Tebet': ['Tebet Barat', 'Tebet Timur', 'Kebon Baru', 'Manggarai', 'Manggarai selatan', 'Menteng Dalam'],
                        'Setia Budi': ['Setia Budi', 'Karet', 'Karet semanggi', 'Karet Kuningan', 'Kuningan Timur', 'Menteng Atas', 'pasar Manggis', 'Guntur']
                    },
                    'Jakarta Utara': {
                        'Cilincing': ['Cilincing', 'Semper Barat', 'Semper Timur', 'Rorotan', 'Sukapura'],
                        'Koja': ['Koja Utara', 'Koja Selatan', 'Rawa Badak', 'Tugu Selatan', 'Tugu Utara'],
                        'Kelapa Gading': ['Kelapa Gading Timur', 'Pegangsaan Dua'],
                        'Tanjung Priok': ['Tanjung Priok', 'Kebon Bawang', 'Sungai Bambu', 'Papanggo', 'Warakas', 'Sunter Agung', 'Sunter jaya'],
                        'Pademangan': ['Pademangan Timur', 'Pademangan Barat', 'Ancol'],
                        'Penjaringan': ['Penjaringan', 'Penjagalan', 'Pluit', 'Kapuk Muara', 'Kamal Muara']
                    },
                    'Jakarta Timur': {
                        'Matraman': ['Utan Kayu Selatan', 'Utan Kayu Utara', 'Kayu Manis', 'Pal Meriam', 'Kebon Manggis'],
                        'Pulo Gadung': ['Kayu Putih', 'Jati', 'Rawa Mangun', 'Pisangan Timur'],
                        'Jatinaegara': ['Kampung Melayu', 'Bidara Cina', 'Cipinang Cempedak', 'Rawa Bunga', 'Cipinang Besar Selatan', 'Cipinang Besar Utara'],
                        'Duren Sawit': ['Pondok Bambu', 'Duren Sawit', 'Pondok Kelapa', 'Malak Jaya', 'Malaka sari', 'Pondok Kopi', 'Klender', 'Kramat Jati', 'Batu Ampar', 'Bale Kambang', 'Kampung Tengah', 'Dukuh', 'Cawang', 'Cililitan'],
                        'Makasar': ['Pinang Ranti', 'Makasar', 'Halim Perdana Kusuma', 'Cipinang Melayu', 'Kebon Pala'],
                        'Pasar Rebo': ['Gendong', 'Cijantung', 'Baru', 'Kalisari'],
                        'Ciracas': ['Cibubur', 'Kelapa Dua Wetan', 'Ciracas', 'Susukan', 'Rambutan'],
                        'Cipayung': ['Lubang Buaya', 'Ceger', 'Cipayung', 'Pondok rangon', 'Cilangkap', 'Setu', 'Bambu Apus'],
                        'Kec. Cakung': ['Cakung Barat', 'Cakung Timur', 'Rawa Terate', 'Jatinegara', 'Penggilingan', 'Pulo Gebang', 'Ujung Menteng'],
                    },
                    'Depok': {
                        'Sukma Jaya': ['Mekar Jaya', 'Kali Mulya', 'Cilodong', 'Kali Baru', 'Cisalak', 'Abadi Jaya', 'Bhakti Jaya'],
                        'Beji': ['Beji Barat', 'Beji Timur', 'Kemiri Muka', 'Pondok Cina', 'Kukusan', 'Tanah Baru', 'Citayam (depok)'],
                        'Pancoran Mas': ['Depok', 'Depok Jaya', 'Mampang', 'Pancoran Mas'],
                        'Limo': ['Desa Krukut', 'Desa Gandul', 'Desa Pangkalan Jati', 'Desa pangkalan Jati Baru', 'Desa Cinere'],
                    },
                    'Tangerang': {
                        'Tangerang': ['Sukaasih', 'Sukarasa', 'Cikokol', 'Kelapa Indah', 'Sukasari', 'Babakan', 'Buaran Indah', 'Tanah Tinggi'],
                        'Karawaci': ['Koang Jaya', 'Nambo Jaya', 'Pabuaran Tumpeng', 'Pasar Baru', 'Bugel', 'Gerendeng', 'MargaSari', 'Suka Jadi', 'Cimone', 'Cimone Baru', 'Pabuaran', 'Sumur Pancing', 'Bojong Jaya', 'Karawaci', 'Karawaci Baru', 'Nusa Jaya'],
                        'Batu Ceper': ['Batu Sari', 'Poris Gaga', 'Poris Gaga Baru', 'Batu Ceper', 'Kebon Besar', 'Poris Jaya'],
                        'Negla Sari': ['Karang Anyar', 'Selapang Jaya', 'Kedaung', 'Kedaung Wetan', 'Mekar Sari', 'Negla Sari'],
                        'Benda': ['Belendung', 'Jurumudi Baru', 'Jurumudi', 'Benda', 'Panjang'],
                        'Jatiuwung': ['roncong (k.permai saja)'],
                        'Cipondoh': ['Poris Plawad', 'Poris Plawad Indah', 'Poris Plawad Utara', 'Kenanga', 'Gondrong', 'Petir', 'Ketapang', 'Cipondoh', 'Cipondoh Indah', 'Cipondoh Makmur'],
                        'Pinang': ['Cipete', 'Pakojan', 'Panungganan Selatan', 'Panungganan Timur', 'Panungganan Utara', 'Kunciran', 'Kunciran Indah', 'Kunciran Jaya', 'Narogtog', 'Pinang', 'Sudimara Pinang'],
                        'Ciledug': ['Sudimara Barat', 'Sudimara Jaya', 'Sudimara Selatan', 'Sudimara Timur', 'Tajur', 'Paninggilan', 'Paninggilan Utara', 'Parung Serab'],
                        'Larangan': ['Gaga', 'Larangan Indah', 'Larangan Utara', 'Cipadu', 'Cipadu jaya', 'Larangan Selatan', 'Kreo', 'Kreo Selatan'],
                        'Karang Tengah': ['Karang Mulya', 'Karang Tengah', 'Karang Timur', 'Pendurenan', 'Pondok Pucung', 'Parung Jaya', 'Pondok Bahar'],
                        'Pondok Aren': ['Pondok Betung', 'Jurangmangu Timur', 'Jurangmangu Barat', 'Pondok Aren', 'Pondok Karya Kacang', 'Pondok Karya Barat', 'Pondok Karya Timur', 'Parigi', 'Parigi Baru', 'Pondok Pucung (pdk aren)'],
                        'BSD': ['Serpong', 'Muncul (hanya puspitek saja)', 'Setu', 'Babakan', 'Rawa Buntu (Rawa Mekar Jaya)', 'Lengkong Gudang', 'Lengkong Wetan', 'Jelupang', 'Paku jaya', 'Pakulonan', 'Pondok Jagung'],
                        'Ciputat': ['Cipayung', 'Ciputat', 'Cempaka Putih', 'Pondok Ranji', 'Rempoa', 'Rengas', 'Sawah Baru', 'Sawah Lama'],
                        'Pamulang': ['Jombang', 'Sarua', 'Sarua Indah', 'Bambu Apus', 'Kedaung', 'Pondok Benda Baru', 'Pondok Benda Lama', 'Pamulang Barat', 'Pamulang Timur', 'Pondok Cabe Ilir', 'Pondok Cabe Udik', 'Cirendeu', 'Pisangan'],
                        'Curug': ['Bencongan( Lippo Karawaci)'],
                    },
                    'Bekasi': {
                        'Bekasi Timur': ['Duren Jaya', 'Aren jaya', 'Bekasi Jaya', 'Margahayu', 'Rawa lumbu', 'Jati Mulya'],
                        'Bekasi Utara': ['Teluk Pucung', 'Perwira', 'Harapan Baru', 'Harapan Jaya', 'Kaliabang Tengah'],
                        'Bekasi Barat': ['Kota Baru', 'Bintara', 'Kranji', 'Bintara Jaya', 'Jaka Sampurna'],
                        'Bekasi Selatan': ['Kayu Ringin Jaya', 'Jaka Mulya', 'Jaka Setia', 'Pekayon Jaya'],
                        'Medan Satria': ['Pejuang', 'Medan Satria', 'Kali Baru'],
                        'Pondok Gede': ['Jatiwaringin', 'Jati Bening', 'Jati Makmur', 'Jati Rahayu', 'Jati Warna', 'Jati Kramat', 'Jati Asih'],
                    }
                },
                surabaya: {
                    'Kota Surabaya': [
                        'Surabaya', 'Asemrowo', 'Benowo', 'Bubutan', 'Bulak', 'Dukuh Pakis', 'Gayungan', 'Genteng (Surabaya)', 'Gubeng', 'Gununganyar',
                        'Jambangan', 'Karangpilang', 'Kenjeran', 'Krembangan', 'Lakar Santri', 'Mulyorejo', 'Pabean Cantikan', 'Pakal', 'Rungkut',
                        'Sambikerep', 'Sawahan (Surabaya)', 'Semampir', 'Simokerto', 'Sukolilo (Surabaya)', 'Sukomanunggal', 'Tambaksari (Surabaya)',
                        'Tandes', 'Tegalsari (Surabaya)', 'Tenggilis Mejoyo', 'Wiyung', 'Wonocolo', 'Wonokromo'
                    ],
                    'Kab. Sidoarjo': [
                        'Sidoarjo', 'Balongbendo', 'Buduran', 'Candi', 'Gedangan (Sidoarjo)', 'Jabon', 'Krembung', 'Krian', 'Porong', 'Prambon (Sidoarjo)',
                        'Sedati', 'Sukodono (Sidoarjo)', 'Taman (Sidoarjo)', 'Tanggulangin', 'Tarik', 'Tulangan', 'Waru (Sidoarjo)', 'Wonoayu'
                    ]
                }
            }
        }
    }

    WarehouseDeclaration = {
        jakarta: {
            shippingValue: {
                [K.Delivery]: '2',
                [K.PickUp]: '3',
                [K.MotorDelivery]: '6'
            },
            value: 'jakarta',
            dictionary: 'warehouse_jakarta'
        },
        surabaya: {
            shippingValue: {
                [K.Delivery]: '7',
                [K.PickUp]: '8',
                [K.MotorDelivery]: '9'
            },
            value: 'surabaya',
            dictionary: 'warehouse_surabaya'
        }
    }

    ID = {
        /** ID = 2 */
        delivery: '2',
        /** ID = 3 */
        pickUp: '3',
        /** ID = 4 */
        aramex: '4',
        /** ID = 5 */
        pickUpHochiminh: '5',
        /** ID = 6 */
        motorDelivery: '6',
        /** ID = 7 */
        deliverySBY: '7',
        /** ID = 8 */
        pickUpSBY: '8',
        /** ID = 9 */
        motorDeliverySBY: '9',
        /** ID = 10 */
        pickUpTaguig: '32',
        /** ID = 501 */
        samedayDelivery: '501'
    }

    name = {
        delivery: 'delivery',
        pickUp: 'pickUp',
        aramex: 'aramex',
        pickUpHochiminh: 'pickUpHochiminh',
        motorDelivery: 'motorDelivery',
        deliverySBY: 'deliverySBY',
        pickUpSBY: 'pickUpSBY',
        motorDeliverySBY: 'motorDeliverySBY',
        pickUpTaguig: 'pickUpTaguig',
        samedayDelivery: 'samedayDelivery'
    }

    type = {
        delivery: 'delivery',
        pickUp: 'pickUp',
        aramex: 'aramex',
        motorDelivery: 'motorDelivery',
        samedayDelivery: 'samedayDelivery'
    }

    dictionary = {
        delivery: 'delivery',
        pickUp: 'pickup',
        aramex: 'aramex',
        pickUpHochiminh: 'pickuphochiminh',
        motorDelivery: 'motordelivery',
        deliverySBY: 'delivery',
        pickUpSBY: 'pickup',
        motorDeliverySBY: 'motordelivery',
        pickUpTaguig: 'pickup-taguig',
        samedayDelivery: 'samedayDelivery'
    }

    IDToName = {
        '2': 'delivery',
        '3': 'pickUp',
        '4': 'aramex',
        '5': 'pickUp', // Pick Up Hochiminh
        '6': 'motorDelivery',
        '7': 'deliverySBY', // Delivery for IDN - Surabaya Warehouse
        '8': 'pickUpSBY', // PickUp for IDN - Surabaya Warehouse
        '9': 'motorDeliverySBY', // Motor Delivery for IDN - Surabaya Warehouse
        '32': 'pickUpTaguig', // PickUp for PHL - Taguig
        '501': 'samedayDelivery' // sameday delivery
    }

    IDToType = {
        '2': 'delivery',
        '3': 'pickUp',
        '4': 'aramex',
        '5': 'pickUp', // Pick Up Hochiminh
        '6': 'motorDelivery',
        '7': 'delivery', // Delivery for IDN - Surabaya Warehouse
        '8': 'pickUp', // PickUp for IDN - Surabaya Warehouse
        '9': 'motorDelivery', // Motor Delivery for IDN - Surabaya Warehouse
        '32': 'pickUp', // PickUp for PHL - Taguig
        '501': 'samedayDelivery' // sameday delivery
    }

    getShippingName(shippingID = '') {
        if (isNothing(shippingID)) shippingID = checkOutStore.shipping
        return this.IDToName[shippingID]
    }

    getShippingType(shippingID = '') {
        if (isNothing(shippingID)) shippingID = checkOutStore.shipping
        return this.IDToType[shippingID]
    }

    isAramex(shippingID = '') {
        return this.getShippingType(shippingID) === this.type.aramex
    }

    isDelivery(shippingID = '') {
        return this.getShippingType(shippingID) === this.type.delivery
    }

    isPickup(shippingID = '') {
        return this.getShippingType(shippingID) === this.type.pickUp
    }

    isMotorDelivery(shippingID = '') {
        return this.getShippingType(shippingID) === this.type.motorDelivery
    }

    isSamedayDelivery(shippingID = '') {
        return this.getShippingType(shippingID) === this.type.samedayDelivery
    }

    getWarehouseEnabled() {
        return throatBoolean(this.WarehouseEnabled)
    }

    getWarehouseAcceptance() { 
        return throatArray(this.WarehouseAcceptance) 
    }

    getShippingAcceptance() { 
        return throatArray(this.ShippingAcceptance) 
    }

    isAcceptedMethod() {
        let acceptance = this.getShippingAcceptance()
        if (isArray(acceptance) || isObservableArray(acceptance)) {
            acceptance = acceptance.map((item) => first(item.split('.')))
        } else {
            acceptance = get(acceptance, `[${checkOutStore.warehouse}]`, []).map((item) => first(item.split('.')))
        }
        return someOf(this.getShippingType(), acceptance)
    }

    getPickupAddress() {
        const addressData = throatObject(this.PickupDeclaration.address)
        const omitedData = omit(addressData, ['dictionary', 'value'])
        let dictionary, value
        if (keys(omitedData).length > 0) {
            dictionary = get(omitedData, `${checkOutStore.warehouse}.dictionary`)
            value = get(omitedData, `${checkOutStore.warehouse}.value`)
        } else {
            dictionary = get(addressData, 'dictionary')
            value = get(addressData, 'value')
        }
        if (has(value, 'EN') || has(value, 'en')) {
            value = language.listen(value)
        }
        return {
            dictionary,
            value
        }
    }

    getShippingDeclarationDictionary() {
        // get shipping methods list of current country
        let list = this.getShippingAcceptance()
        // if it not array like, assume as warehouse support type
        if (isArrayLikeObject(list) === false) {
            let legitWarehouse = checkOutStore.warehouse
            if (isNothing(legitWarehouse)) {
                // handle empty value on warehouse by set default to first one
                legitWarehouse = first(this.getWarehouseAcceptance())
                checkOutStore.warehouse = legitWarehouse
            }
            // convert list to legit warehouse data
            list = list[legitWarehouse]
        }

        const method = list.find(item => item.split('.')[0] === this.getShippingType())
        if (method) {
            let key = ''
            if (method.indexOf('.') === -1) {
                key = get(this.ShippingDeclaration, `${method}.default.dictionary`)
            } else {
                key = get(this.ShippingDeclaration, `${method}.dictionary`)
            }
            return key
        } else {
            return ''
        }
    }

}

const core = new classShippingMethods()

export { core as default }
export { core as ShippingMethods }